<template>
  <div>
    <Breadcrumbs
      title="Delivery Schedule Edit"
      :breadcrumbs="[
        { label: 'Delivery Schedule History', path: '/delivery-schedule-history' },
        { label: 'Delivery Schedule Edit', path: '' },
      ]"
    />

    <div class="container-fluid">
      <div class="row project-cards">
        <DeliveryScheduleEditData />
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryScheduleEditData from "@/pages/stock/delivery_schedule_edit/delivery_schedule_edit_data.vue";

export default {
  name: "DeliveryScheduleEdit",

  components: {
    DeliveryScheduleEditData,
  },
};
</script>